
import React from 'react';
import { useTranslation } from 'react-i18next';

const MobileControls = ({ onMove, onRotate, onDrop, onPause }) => {
    const { t } = useTranslation();
    return (
        <div className="fixed bottom-0 left-0 right-0 bg-slate-900/80 p-2 z-20 flex justify-around items-center md:hidden">
            <div className="flex items-center gap-2">
                <button onTouchStart={() => onMove(-1)} className="w-16 h-16 bg-cyan-500/70 rounded-full text-white text-2xl active:bg-cyan-400">◀</button>
                <button onTouchStart={() => onMove(1)} className="w-16 h-16 bg-cyan-500/70 rounded-full text-white text-2xl active:bg-cyan-400">▶</button>
            </div>
            <div className="flex items-center gap-2">
                 <button onTouchStart={onRotate} className="w-16 h-16 bg-purple-600/70 rounded-full text-white text-2xl active:bg-purple-500">↻</button>
                <button onTouchStart={onDrop} className="w-16 h-16 bg-red-600/70 rounded-full text-white text-2xl active:bg-red-500">▼</button>
            </div>
            <button onClick={onPause} className="w-16 h-16 bg-slate-600/70 rounded-full text-white text-lg active:bg-slate-500">{t('synapticStacking.controls.pause')}</button>
        </div>
    );
};

export default MobileControls;
